/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a low number always better?`)
};

const es_bf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Un número bajo siempre es mejor?`)
};

const de_bf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist ein niedriger Wert immer besser?`)
};

const nl_bf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een laag percentage altijd beter?`)
};

const fr_bf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un chiffre bas est-il toujours meilleur ?`)
};

const it_bf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un numero basso è sempre meglio?`)
};

const pt_br2_bf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um número baixo é sempre melhor?`)
};

const pt_bf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um valor baixo é sempre melhor?`)
};

const ja_bf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値は低いほど良いのですか?`)
};

const zh_bf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数值越低就一定越好吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_faq_q4", locale)
	if (locale === "en") return en_bf_faq_q4(inputs)
	if (locale === "es") return es_bf_faq_q4(inputs)
	if (locale === "de") return de_bf_faq_q4(inputs)
	if (locale === "nl") return nl_bf_faq_q4(inputs)
	if (locale === "fr") return fr_bf_faq_q4(inputs)
	if (locale === "it") return it_bf_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_bf_faq_q4(inputs)
	if (locale === "pt") return pt_bf_faq_q4(inputs)
	if (locale === "ja") return ja_bf_faq_q4(inputs)
	return zh_bf_faq_q4(inputs)
};